import FuseUtils from "@fuse/FuseUtils";
import _ from "@lodash";
import { GET_MENSAGENS_NOTICE } from "app/Core/Funcionalidade/Comunicador/Store/Actions/ComunicadorActions";
import * as Helpers from "app/Core/Helpers";
import axios from "axios";
import { dispatcher } from "react-dispatch";
import FirebaseAuthService from "../FirebaseAuthService/FirebaseAuthService";


class XAPPService extends FuseUtils.EventEmitter {

	init() {
		axios.defaults.headers.common["Authorization"] = "Bearer " + this.getAccessToken();
	}

	getAccessToken = () => {
		return window.sessionStorage.getItem("jwt_access_token");
	};

	removeField = (_AField, _AObject) => {
		delete _AObject[_AField];
		return _AObject;
	};

	XappGetTemplateIndexAction = (_ATipo, _AName) => {

		var ARota = "/api/template/" + _ATipo + "/" + _AName;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchGet(ARota)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchGet(ARota)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					Helpers.SetPreload(false);
					reject(error);
				})
				.finally(() => {
					Helpers.SetPreload(false);
				});
		});
	};

	XappGetFuncionalidadeIndexAction = (_ATipo) => {

		var ARota = "/api/funcionalidade/index/" + _ATipo;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchGet(ARota)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchGet(ARota)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappGetTemplateAction = (_ATipo, _AName) => {

		var ARota = "/api/template/" + _ATipo + "/" + _AName;
		if (document.location.host.includes("local.")) {
			ARota += "?c=" + Date.now();
		}
		return new Promise((resolve, reject) => {
			//	Helpers.SetPreload(true);
			FirebaseAuthService.fetchGet(ARota)
				.then(resp => {
					Helpers.SetPreload(false);
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchGet(ARota)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					Helpers.SetPreload(false);
					reject(error);
				})
				.finally(() => {
					Helpers.SetPreload(false);
				});
		});
	};

	XappDoAction = (_AActions, _AParams = {}, _AMethod = "DO") => {

		var ARota = "/api/action/";
		var AOrganizacao = _AParams.organizacao;
		var AEmpresa = _AParams.empresa;
		var AMethod = _AMethod;
		var AActions = _AActions;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappDoActionFactory = (_AEmpresa, _AActions, _ATarget, _AAction, _AValue, _AKeyField, _AConditionsAND = [], _AConditionsOR = [], _AUseLastVal = "1", _AFilter = null, _AContexto = null) => {

		var obj = {};
		Object.entries(_AValue).forEach(([key, value]) => {
			if (_AFilter !== null) {
				if (_AFilter.includes(key)) {
					obj[key] = value;
				}
			}
			else {
				obj[key] = value;
			}
		});

		if (_AKeyField.length > 0)
			obj = this.removeField(_AKeyField, obj);

		_AActions.push({ "Empresa": _AEmpresa, "Action": _AAction, "Target": _ATarget, "Value": obj, "ConditionsAND": _AConditionsAND, "ConditionsOR": _AConditionsOR, "UseLastVal": _AUseLastVal, "Contexto": _AContexto });

		return _AActions;
	};

	XappUploadFile = (_ARota, _AValue) => {
		return new Promise((resolve, reject) => {
			axios.post(_ARota, _AValue,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": "Bearer " + sessionStorage.getItem("jwt_access_token")
					}
				}
			).then(response => {
				if (response.status === 200) {
					resolve(response);
				}
				else if (resp.status === 403) {
					FirebaseAuthService.validateResponse()
						.then((resp) => {
							resolve(resp);
						})
						.catch(error => {
							reject(error);
						});
				}
				else {
					reject("Erro geral ao enviar arquivo.");
				}
			}).catch(error => {
				if (error.response.status === 403) {
					FirebaseAuthService.validateResponse()
						.then((resp) => {
							resolve(resp);
						})
						.catch(error => {
							reject("Permissão negada, entre em contato com o administrador do sistema.");
						});
				}
				else if (error.response.status === 413) {
					reject("O arquivo deve ter um tamanho inferior a 20Mb.");
				}
				else
					reject("Erro: " + error.response.status + " - " + error.response.data.error.message);
			});
		});
	};

	XappUploadFileAction = (_AValue, _AController) => {
		var ARota = "/api/" + _AController + "/";
		return new Promise((resolve, reject) => {
			this.XappUploadFile(ARota, _AValue)
				.then(resp => {
					if (resp === "Reautenticado") {
						this.XappUploadFile(ARota, _AValue).then(resp => resolve(resp));
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => reject(error));
		});
	};

	XappDownloadFileAction = (_AFilename, _ACaminho, _AIDEmpresa, _AMimetype = "") => {
		var ARota = "/api/arquivo/download/" + _AFilename;
		return new Promise((resolve, reject) => {
			axios({
				method: "get",
				url: ARota,
				responseType: "blob",
				headers: {
					"Authorization": "Bearer " + sessionStorage.getItem("jwt_access_token"),
					"Caminho": _ACaminho,
					"Mimetype": _AMimetype,
					"IdEmpresa": _AIDEmpresa,
				}
			}).then(response => {
				if (response.status === 200) {
					resolve(response);
				}
				else {
					reject("Erro geral ao enviar arquivo.");
				}
			}).catch(error => {
				if (error.response.status === 403)
					reject("Permissão negada, entre em contato com o administrador do sistema.");
				else if (error.response.status === 500)
					reject("Ocorreu um erro durante a execução, por favor informe o administrador do sistema.");
				else
					reject("Erro: " + error.response.status + " - " + error.response.statusText);
			});
		});
	};

	XappFile64Action = (_AIDEmpresa, _AIDArquivo, _AIsThumb = "0") => {
		var ARota = "/api/arquivo/image/" + _AIDEmpresa + "/" + _AIDArquivo + "/" + _AIsThumb;
		return new Promise((resolve, reject) => {
			axios({
				method: "get",
				url: ARota,
				headers: {
					"Authorization": "Bearer " + sessionStorage.getItem("jwt_access_token")
				}
			}).then((response) => {
				resolve(response);
			})
				.catch(error => {
					reject("Erro: " + error);
				});
		});
	};

	XappCustomAction = (_AActions, _AParams = {}, _AProcedure, _AMethod = "CUSTOM") => {

		var ARota = "/api/action/";
		var AOrganizacao = _AParams.organizacao;
		var AEmpresa = _AParams.empresa;
		var AMethod = _AMethod;
		var AActions = _AActions;
		var AProcedure = _AProcedure;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions, AProcedure)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions, AProcedure)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappCustomActionFactory = (_AEmpresa, _AActions, _ATarget, _AAction, _AValue, _AKeyField, _AConditionsAND = [], _AConditionsOR = [], _AUseLastVal = "1", _AFilter = null, _AContexto = null) => {
		if (_AKeyField.length > 0)
			_AValue = this.removeField(_AKeyField, _AValue);

		if (_AFilter !== null) {
			var obj = {};
			Object.entries(_AValue).forEach(([key, value]) => {
				if (_AFilter.includes(key)) {
					obj[key] = value;
				}
			});

			_AValue = obj;
		}

		_AActions.push({ "Empresa": _AEmpresa, "Action": _AAction, "Target": _ATarget, "Value": _AValue, "ConditionsAND": _AConditionsAND, "ConditionsOR": _AConditionsOR, "UseLastVal": _AUseLastVal, "Contexto": _AContexto });

		return _AActions;
	};

	XappFlowAction = (_AActions, _AParams = {}, _AMethod = "FLOW") => {

		var ARota = "/api/flow/";
		var AOrganizacao = _AParams.organizacao;
		var AEmpresa = _AParams.empresa;
		var AMethod = _AMethod;
		var AActions = _AActions;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappFlowActionFactory = (_AEmpresa, _AActions, _ATarget, _AAction, _AValue, _AKeyField, _AConditionsAND = [], _AConditionsOR = [], _AUseLastVal = "1", _AFilter = null, _AContexto = null) => {
		if (_AKeyField.length > 0)
			_AValue = this.removeField(_AKeyField, _AValue);

		if (_AFilter !== null) {
			var obj = {};
			Object.entries(_AValue).forEach(([key, value]) => {
				if (_AFilter.includes(key)) {
					obj[key] = value;
				}
			});

			_AValue = obj;
		}

		_AActions.push({ "Empresa": _AEmpresa, "Action": _AAction, "Target": _ATarget, "Value": _AValue, "ConditionsAND": _AConditionsAND, "ConditionsOR": _AConditionsOR, "UseLastVal": _AUseLastVal, "Contexto": _AContexto });

		return _AActions;
	};

	XappSelActionFactory = (_AEmpresa, _AName, _AActions, _ATarget, _AValue, _AAction, _AConditionsAND = [], _AConditionsOR = [], _APagina = 1, _AContexto = null) => {
		_AActions.push({ "Empresa": _AEmpresa, "Name": _AName, "Action": _AAction, "Target": _ATarget, "Value": _AValue, "ConditionsAND": _AConditionsAND, "ConditionsOR": _AConditionsOR, "Usuario": sessionStorage.getItem("username"), "Pagina": _APagina, "Contexto": _AContexto });
		return _AActions;
	};

	XappSelAction = (_AActions, _AParams = {}, _AMethod = "SEL") => {
		var ARota = "/api/action/";
		var AOrganizacao = _AParams.organizacao;
		var AEmpresa = _AParams.empresa;
		var AMethod = _AMethod;
		var AActions = _AActions;
		return new Promise((resolve, reject) => {
			Helpers.SetPreload(true);
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
					if (!_.isUndefined(resp.notice) && !_.isNull(resp.notice) && resp.notice.length > 0) {
						dispatcher.dispatch(GET_MENSAGENS_NOTICE, resp.notice);
					}
					Helpers.SetPreload(false);
				})
				.catch(error => {
					Helpers.SetPreload(false);
					reject(error);
				})
				.finally(() => {
					Helpers.SetPreload(false);
				});
		});
	};

	XappGetSession = () => {
		return window.sessionStorage.getItem("jwt_access_token");
	};

	XappRegisterAction = (_AActions, _AMethod) => {

		var ARota = "/Register/";
		var AOrganizacao = "";
		var AEmpresa = "0";
		var AMethod = _AMethod;
		var AActions = _AActions;
		var AProcedure = "spdoactionregistro";

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions, AProcedure)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions, AProcedure)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappLookupActionFactory = (_ATarget, _AActions, _AConditionsAND, _AConditionsOR) => {
		_AActions.push({ "Target": _ATarget, "ConditionsAND": _AConditionsAND, "ConditionsOR": _AConditionsOR });
		return _AActions;
	};

	XappLookupAction = (_AActions) => {

		var ARota = "/api/action/";
		var AOrganizacao = "";
		var AEmpresa = "";
		var AActions = _AActions;
		var AMethod = "LOOKUP";

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappLojaAction = (_AActions, _AMethod) => {

		var ARota = "/api/Loja/";
		var AOrganizacao = "";
		var AEmpresa = "";
		var AMethod = _AMethod;
		var AActions = _AActions;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappLojaActionFactory = (_AName, _AActions, _AAction, _AValue, _AConditionsAND) => {
		_AActions.push({ "Name": _AName, "Action": _AAction, "Value": _AValue, "ConditionsAND": _AConditionsAND });
		return _AActions;
	};

	XappEmpresaAction = (_ANome, _ACidade, _AEstado) => {

		var ARota = "/api/Empresa/" + _ANome + "/" + _ACidade + "/" + _AEstado;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchGet(ARota)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchGet(ARota)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappCidadeAction = (_ALatitude, _ALongitude) => {

		var ARota = "/api/Cidade/" + _ALatitude + "/" + _ALongitude;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchGet(ARota)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchGet(ARota)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	ExportarPDFAction = (_AValue) => {
		var ARota = "/api/arquivo/";
		return new Promise((resolve, reject) => {
			axios.put(ARota, _AValue,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": "Bearer " + sessionStorage.getItem("jwt_access_token")
					}
				}
			).then(response => {
				if (response.status === 200) {
					resolve(response);
				}
				else {
					reject("Erro geral ao enviar arquivo.");
				}
			}).catch(error => {
				if (error.response.status === 403)
					reject("Permissão negada, entre em contato com o administrador do sistema.");

				else
					reject("Erro: " + error.response.status + " - " + error.response.data.error.message);
			});
		});
	};

	XappETLAction = (_AValue, _AMethod) => {
		var ARota = "/api/etl/" + _AMethod + "/";
		return new Promise((resolve, reject) => {
			axios.post(ARota, _AValue,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": "Bearer " + sessionStorage.getItem("jwt_access_token")
					}
				}
			).then(response => {
				if (response.status === 200) {
					resolve(response);
				}
				else {
					reject("Erro geral ao enviar arquivo.");
				}
			}).catch(error => {
				if (error.response.status === 403)
					reject("Permissão negada, entre em contato com o administrador do sistema.");

				else
					reject("Erro: " + error.response.status + " - " + error.response.data.error.message);
			});
		});
	};

	XappRouterAction = (_AActions, _AParams = {}, _AMethod = "DO") => {

		var ARota = "/api/router/";
		var AOrganizacao = _AParams.organizacao;
		var AEmpresa = _AParams.empresa;
		var AMethod = _AMethod;
		var AActions = _AActions;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappRouterActionFactory = (_AEmpresa, _AActions, _ATarget, _AAction, _AValue, _AKeyField, _AConditionsAND = [], _AConditionsOR = [], _AUseLastVal = "1", _AFilter = null) => {

		var obj = {};
		Object.entries(_AValue).forEach(([key, value]) => {
			if (_AFilter !== null) {
				if (_AFilter.includes(key)) {
					obj[key] = value;
				}
			}
			else {
				obj[key] = value;
			}
		});

		if (_AKeyField.length > 0)
			obj = this.removeField(_AKeyField, obj);

		_AActions.push({ "Empresa": _AEmpresa, "Action": _AAction, "Target": _ATarget, "Value": obj, "ConditionsAND": _AConditionsAND, "ConditionsOR": _AConditionsOR, "UseLastVal": _AUseLastVal });

		return _AActions;
	};

	XappIntegracaoAction = (_AActions, _AParams = {}, _AMethod) => {

		var ARota = "/api/integracao/";
		var AOrganizacao = _AParams.organizacao;
		var AEmpresa = _AParams.empresa;
		var AMethod = _AMethod;
		var AActions = _AActions;

		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, AOrganizacao, AEmpresa, AMethod, AActions)
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	XappIntegracaoActionFactory = (_AEmpresa, _AActions, _ATarget, _AAction, _AValue) => {

		_AActions.push({ "Empresa": _AEmpresa, "Action": _AAction, "Target": _ATarget, "Value": _AValue });

		return _AActions;
	};

	getDocumentoAtendimento = (_ARota) => {
		try {
			return new Promise((resolve, reject) => {
				var myHeaders = new Headers();
				myHeaders.append("Authorization", "Bearer " + this.getAccessToken());

				fetch(_ARota, {
					method: "get",
					headers: myHeaders,
				}).then(resp => {
					resp.text().then(response => resolve(response));
				}).catch(error => reject(error));
			});
		}
		catch (error) {
			alert("Erro ao efetuar requisição, entre em contato com o administrador do sistema.");
		}
	};

	XappMensagemAction = (_AActions, _AParams, _AMethod) => {

		var ARota = "/api/mensagem/";
		return new Promise((resolve, reject) => {
			FirebaseAuthService.fetchPost(ARota, _AParams?.organizacao, _AParams?.empresa, _AMethod, _AActions, "spdoactionmensagem")
				.then(resp => {
					if (resp === "Reautenticado") {
						FirebaseAuthService.fetchPost(ARota, _AParams?.organizacao, _AParams?.empresa, _AMethod, _AActions, "spdoactionmensagem")
							.then(resp => {
								resolve(resp);
							});
					}
					else {
						resolve(resp);
					}
				})
				.catch(error => {
					reject(error);
				});
		});
	};

	getUrlHelp = (_APath = "") => {
		let AProduto = document.location.host.split(".")[1];

		var ARota = "/site/gethelp/?produto=" + AProduto + "&path=" + _APath;
		return new Promise((resolve, reject) => {
			axios({ method: "get", url: ARota }).then((response) => {
				resolve(response.data);
			})
				.catch(error => {
					reject("Erro: " + error);
				});
		});
	};
}

const instance = new XAPPService();
export default instance;


